<section class="under-construction-wrap">
  <article class="under-construction-card">
    <p class="eyebrow">{{ 'serviceUnavailable.eyebrow' | translate }}</p>
    <h1>{{ 'serviceUnavailable.title' | translate }}</h1>
    <p class="lead">{{ 'serviceUnavailable.description' | translate }}</p>
    <p>
      {{ 'serviceUnavailable.contact' | translate }}
      <a href="mailto:vorstand@rebelspride.de">vorstand@rebelspride.de</a>
    </p>

    <div class="actions">
      <p-button [label]="'serviceUnavailable.retry' | translate" icon="pi pi-refresh" (onClick)="checkBackendAgain()" />
    </div>
  </article>
</section>
